var React = require('react');

function Reports (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".a{fill:none;stroke:#000;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;}")),React.createElement("path",{"className":"a","d":"M23.25,20.985,21.76,18.75V13.5c0-2-3.8-4.14-5.25-5.25","key":1}),React.createElement("path",{"className":"a","d":"M18.44,14.793,14.792,11.87a1.3,1.3,0,0,0-1.843,1.843L16.482,17.7v2.5c0,1.181,1.688,3.045,1.688,3.045","key":2}),React.createElement("path",{"className":"a","d":"M13.51,21.75H2.134A1.375,1.375,0,0,1,.76,20.375V2.124A1.374,1.374,0,0,1,2.134.75h13A1.375,1.375,0,0,1,16.51,2.124V13.247","key":3}),React.createElement("polyline",{"className":"a","points":"9.76 3.75 12.76 3.75 12.76 6.75","key":4}),React.createElement("line",{"className":"a","x1":"12.76","y1":"3.75","x2":"3.76","y2":"12","key":5}),React.createElement("line",{"className":"a","x1":"5.25","y1":"15.75","x2":"5.25","y2":"18.75","key":6}),React.createElement("line",{"className":"a","x1":"8.25","y1":"13.5","x2":"8.25","y2":"18.75","key":7})]);
}

Reports.defaultProps = {"viewBox":"0 0 24 24"};

module.exports = Reports;

Reports.default = Reports;



//////////////////
// WEBPACK FOOTER
// ./src/components/icon/svgs/reports.svg
// module id = 1081
// module chunks = 0